var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErrorCaseImportCsv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 78
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17841"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1548",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(0 6)",
    fill: "#efe1e4"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "check",
    transform: "translate(3 .832)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1548",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(0 .168)",
    fill: "#fa0f43",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31686",
    d: "M50.129 50.297a3.038 3.038 0 01-4.258 0L36 40.426l-9.871 9.871a3.011 3.011 0 11-4.258-4.258l9.871-9.871-9.871-9.871a3.011 3.011 0 014.258-4.258L36 31.91l9.871-9.871a3.011 3.011 0 114.258 4.258l-9.871 9.871 9.871 9.871a3.038 3.038 0 010 4.258z",
    fill: "#fff"
  })))));
}

export default SvgErrorCaseImportCsv;